import AbstractDocument from "@/services/firebase/firestore/documents/AbstractDocument";
import {Expose} from "class-transformer";
import ModelFAQButtonLangs from "@models/v2/firebase/faq-buttons/ModelFAQButtonLangs";
import {DocumentTypes} from "@/services/firebase/firestore/documents/DocumentTypes";

export default class DocumentFAQButtons extends AbstractDocument {
	protected _type: DocumentTypes = DocumentTypes.FAQ_BUTTONS;

	@Expose({ name: 'loginView' })
	private _loginView: ModelFAQButtonLangs | null = null;

	@Expose({ name: 'paymentsView' })
	private _paymentsView: ModelFAQButtonLangs | null = null;

	@Expose({ name: 'settingsView' })
	private _settingsView: ModelFAQButtonLangs | null = null;

	constructor() {
		super();
	}

	get loginView() {
		return this._loginView;
	}

	get paymentsView() {
		return this._paymentsView;
	}

	get settingsView() {
		return this._settingsView;
	}
}
